import {
    getFromLocalStorage,
    sessionTokenLsKeyword,
} from '@/shared/localStorage/localStorageRepository'
import { refreshAccessToken, request } from './apiClient'

export const putWithAuth = async (
    route: string,
    includeBaseUrl?: boolean,
    body?: string,
    profileId?: string
) => {
    let sessionToken = getFromLocalStorage(sessionTokenLsKeyword)

    if (!sessionToken) {
        const newToken = await refreshAccessToken()
        if (!newToken) {
            throw new Error('No auth token available')
        }
        sessionToken = newToken
    }

    const response = await request(
        'PUT',
        route,
        sessionToken,
        includeBaseUrl,
        body,
        profileId
    )
    return response
}

export const get = async (route: string, includeBaseUrl?: boolean) => {
    const response = await request('GET', route, undefined, includeBaseUrl)
    return response
}
export const getWithAuth = async (route: string, includeBaseUrl?: boolean) => {
    let sessionToken = getFromLocalStorage(sessionTokenLsKeyword)

    if (!sessionToken) {
        const newToken = await refreshAccessToken()
        if (!newToken) {
            throw new Error('No auth token available')
        }
        sessionToken = newToken
    }

    const response = await request(
        'GET',
        route,
        sessionToken,
        includeBaseUrl,
        undefined
    )

    return response
}

export const post = async (
    route: string,
    includeBaseUrl?: boolean,
    body?: string
) => {
    const response = await request(
        'POST',
        route,
        undefined,
        includeBaseUrl,
        body
    )
    return response
}

export const postWithAuth = async (
    route: string,
    includeBaseUrl?: boolean,
    body?: string,
    profileId?: string
) => {
    let sessionToken = getFromLocalStorage(sessionTokenLsKeyword)

    if (!sessionToken) {
        const newToken = await refreshAccessToken()
        if (!newToken) {
            throw new Error('No auth token available')
        }
        sessionToken = newToken
    }

    const response = await request(
        'POST',
        route,
        sessionToken,
        includeBaseUrl,
        body,
        profileId
    )
    return response
}
